<template>
  <div>
    <div
      class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup"
      v-if="addNewNote"
      :class="{ show: addNewNote }"
    >
      <div class="cstm-modal medium fixed_medium">
        <div class="header">
          <h4>{{ fileType }} Note</h4>
          <button @click.stop="closeCreateModal" class="close-modal">
            &times;
          </button>
        </div>
        <div class="modal-content border_btm p-4">
          <vs-input
            placeholder="Note Title"
            v-model="createPayload.title"
            class="w-full mb-4"
          />

          <div>
            <h4
              style="cursor: pointer"
              class="mb-4"
              @click="add_description = !add_description"
            >
              <a class="primary">+ Add Description</a>
            </h4>
          </div>
          <vs-textarea
            v-model="createPayload.description"
            v-if="add_description"
          />
          <editor
            ref="tinyMce"
            v-model="createPayload.body"
            :api-key="tinyMceApi"
            :init="initializeTinyMce"
          />

          <div class="py-4">
            <h4 class="mb-4">Linked Online Resources</h4>
            <vs-button type="border" icon="add" @click="addFileModal = true"
              >Add file</vs-button
            >
            <div v-if="addFileModal">
              <FileUpload
                section_type="Notes"
                :multiplefile="true"
                @getFileIdHeader="getIdFile"
                :file_repository_id="repository_id"
                :filesInfo="filesInfo"
                @deletedIndex="deletedIndex"
                ref="fileUploadRef"
              />
            </div>
          </div>
        </div>
        <vs-button class="block mx-auto my-4" @click="createNoteTemplate"
          >Save</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import FileUpload from '@/views/pages/v1/notes/components/Template/NotesFileComponent.vue'
import { repository } from '@/mixins/repository'
import Editor from '@tinymce/tinymce-vue'
import { createNote, updateNote } from '@/api/lesson_notes.js'

export default {
  components: {
    FileUpload,
    editor: Editor
  },
  mixins: [repository],
  props: {
    addNewNote: {
      default: false
    },
    fileType: {
      default: ''
    },
    editPayload: {
      default: ''
    }
  },
  data () {
    return {
      addFileModal: false,
      add_description: true,
      tinyMceApi: '',
      filesInfo: [],
      initializeTinyMce: {
        setup: (editor) => {
          editor.ui.registry.addIcon(
            'filesIcon',
            '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>'
          )
          editor.ui.registry.addIcon(
            'gDriveIcon',
            '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>'
          )

          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            classes: 'myClass',

            onAction: () => {
              this.importModelRepo(editor)
            }
          })
          editor.ui.registry.addButton('gDrive', {
            // text: 'Gdrive',
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction: () => {
              this.gDrive(editor)
            }
          })
        },
        height: 300,

        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.images_upload_handler,
        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
          'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \        table alignleft aligncenter alignright alignjustify | \        bullist numlist outdent indent | removeformat | help'
      },
      createPayload: {
        schedule_id: null,
        course_id: null,
        title: '',
        description: '',
        body: '',
        has_all_subject: true,
        save_type: false,
        originated_from: 'COURSE',
        is_private: false,
        files: [],
        topic_type: 6
      }
    }
  },
  created () {
    this.getRepositoryId(54)
  },
  mounted () {
    console.log(this.editPayload)
    if (this.fileType === 'Edit') {
      this.createPayload.title = this.editPayload.name
      this.createPayload.description = this.editPayload.description
      this.createPayload.body = this.editPayload.note[0].body
      this.createPayload.has_all_subject =
        this.editPayload.note[0].has_all_subject
      this.createPayload.files = this.editPayload.note[0].files.length > 0 ? this.editPayload.note[0].files.map((ele) => {
        return ele.id
      }) : []

      //this.filesInfo = this.editPayload.note[0].files
      this.filesInfo = this.editPayload.note[0].files.map((ele) => {
        return {
          file_name: ele.file_name,
          size: ele.size,
          file_type: ele.file_type,
          file_path: ele.file_path
        }
      })
      this.addFileModal = this.editPayload.note[0].files.length > 0
    }
  },
  methods: {
    closeCreateModal () {
      this.$emit('closeCreateModal', true)
    },
    deletedIndex (deleteIndex) {
      this.filesInfo.splice(deleteIndex, 1)
      this.createPayload.files = []
    },
    getIdFile (obj) {
      console.log(obj)
      this.createPayload.files.push(obj)
      console.log(this.createPayload)
    },
    async createNoteTemplate () {
      if (this.fileType === 'Add') {
        const payload = {
          ...this.createPayload
        }
        const { data } = await createNote(
          localStorage.getItem('customer_id'),
          payload
        )
        
        
        this.createPayload = {...this.createPayload, note: data.data.note.id, title: data.data.note.title, description:data.data.note.description}
        const topic_obj = this.createPayload
        this.$emit('createTopic', topic_obj)
        this.setDefault()
       
      } else {
        console.log(this.createPayload.files)
        console.log(this.editPayload)
        const payload = {
          ...this.createPayload,
          id: this.editPayload.note[0].id,
          name: this.editPayload.note[0].title
        }

        await updateNote(
          localStorage.getItem('customer_id'),
          payload,
          this.editPayload.note[0].id
        )

        const topic_obj = Object.assign(payload, {
          note: this.editPayload.note[0].id,
          id: this.editPayload.id
        })

        this.setDefault()
        this.$emit('updateEachTopic', topic_obj)
      }
    },

    setDefault () {
      this.createPayload.title = null
      this.createPayload.description = null
      this.createPayload.body = null
      this.createPayload.files = []
      this.closeCreateModal()
    }
  }
}
</script>